import { render, staticRenderFns } from "./TableElementDocRelacionados.vue?vue&type=template&id=6a12fae1&"
import script from "./TableElementDocRelacionados.vue?vue&type=script&lang=js&"
export * from "./TableElementDocRelacionados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports